<template>
    <v-container fluid>
        <v-btn
            :loading="representativesWithInfo === null"
            @click="newRepresentative"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Representatives ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="representativesWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="representativeWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="representativeWithInfo in representativesWithInfo"
                >
                    <!--@click="loadRepresentativeForm(representativeWithInfo.entity)"-->
                    <v-card
                        @click="loadRepresentativeForm(representativeWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            #{{representativeWithInfo.entity.id}}
                            <br />
                            {{representativeWithInfo.entity.name}}
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="representativeFormVisible"
            width="500px"
        >
            <RepresentativeForm
                :entity-in="representativeFormRepresentative"
                :key="representativeFormKey"
                @close="closeRepresentativeForm"
                @deleted="deleteRepresentative"
                @saved="updateRepresentative"
            />
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Representative from "../models/Representative.model";
import uuid4 from "../helpers/uuid4";
import Representative from "../models/Representative.model";
import RepresentativeForm from "../components/forms/RepresentativeForm";

export default {
    name: "Representatives",
    props: ["status"],
    data: function() {
        return {
            //main data
            representativesWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            representativeFormVisible: false,
            representativeFormKey: 0,
            representativeFormRepresentative: new Representative()
        };
    },
    mounted: function() {
        this.getRepresentatives();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        RepresentativeForm
        //
    },
    methods: {
        getRepresentatives() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("representatives/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(representativesResponse => {
                    if (this.requestId == representativesResponse.requestId) {
                        this.representativesWithInfo =
                            representativesResponse.data.page;
                        this.totalMatches = representativesResponse.data.total;
                        this.pageSize = representativesResponse.data.pageSize;
                        this.pageNo = representativesResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            representativesResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.representativesWithInfo !== null)
                this.representativesWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getRepresentatives,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newRepresentative() {
            var representative = new Representative();
            representative.id = 0;
            this.loadRepresentativeForm(representative);
        },
        loadRepresentativeForm(representative) {
            this.representativeFormRepresentative = new Representative().set(
                representative
            );
            this.representativeFormKey = representative.id;
            this.representativeFormVisible = true;
        },
        closeRepresentativeForm() {
            this.representativeFormVisible = false;
            this.representativeFormRepresentative = new Representative();
            this.representativeFormKey = null;
        },
        updateRepresentative() {
            this.paginationDebounce(0);
        },
        deleteRepresentative() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
